import { getBaseUrl } from '../../../config/env';

export const browseEndpoints = {
  getTopPicks: () => ({
    url: `${getBaseUrl()}/api/v1/Applications`,
    method: 'GET' as const,
  }),
};
